import { Outlet, Route, Routes } from 'react-router-dom';
import {
  BaseModule,
  // MenuRoute,
  Modules,
  VirtualRouteHookProvider,
  getI18n,
} from 'scbk-services';
import { ErrorComponent, RootLayout } from 'scbk-shared-module';

import { CommonConfig, SampleConfig } from 'scbk-frontend-sample/config';
import { MockConfig } from 'scbk-frontend-sample/mocks';

import '../App.css';

import { routeObjects } from './routeObjects';

export const SampleModuleRoutes = () => {
  return (
    <BaseModule
      module={Modules.SAMPLE}
      moduleConfig={SampleConfig}
      commonConfig={CommonConfig}
      mockConfig={MockConfig}
      metaEnv={import.meta.env}
    >
      <Routes>
        <Route element={<RootLayout i18n={getI18n()} />}>
          <Route element={<VirtualRouteHookProvider outlet={Outlet} />}>
            {routeObjects?.map((route) => (
              <Route key={route.id} path={route.path} element={route.element} />
            ))}
          </Route>
        </Route>
        <Route path="*" element={<ErrorComponent errorCode={'404'} />} />
      </Routes>
    </BaseModule>
  );
};
